<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page"></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 intro">
          <h1>Cookie Policy</h1>
          <hr />
        </div>
      </div>
      <div class="internal-content">
        <p><strong>What are Cookies?</strong></p>
        <br />
        <p>
          Cookies are small amounts of information which some websites store on
          your computer to make it easier for you to log on to and use them
          during future visits. In reality, a cookie is a small text file which
          is stored by the user's browser and contains data, not code, so it
          can't contain a virus or spyware. This doesn't mean that all cookies
          are harmless in intent, but they can only ever store information.
        </p>
        <br />
        <p><strong>How we use your information</strong></p>
        <br />
        <p>
          Organisation uses 'analytical' cookies on this site to allow us to
          monitor website traffic and analyse how visitors use it via Google
          Analytics. This service tracks information about how visitors interact
          with the site, including the number of visitors to our website, where
          visitors have come to the website from, and the pages they visit. We
          use this information to help us improve our website.
        </p>
        <br />
        <p>
          Such information will not identify you personally as it is merely
          statistical data about our visitors and their use of our website. This
          statistical data is completely anonymous and does not identify any
          personal details whatsoever.
        </p>
        <br />
        <p>
          All computers have the ability to decline cookies. You can configure
          your web browser to refuse cookies, or to be informed if a cookie is
          set. You can find out how to do this by clicking "help" on your
          browser menu.
        </p>
        <br />
        <p>
          By using our website, you agree that we can place these types of
          cookies on your device.
        </p>
        <br>
        <p>
          If you wish to find out more about cookies visit &nbsp;<a
          target="_blank"
          rel="nofollow noopener"
            href="http://www.allaboutcookies.org/"
            >www.allaboutcookies.org</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cookies",
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Cookies.vue